import React from 'react'
import { withRouter } from 'react-router-dom'
import { DatePicker, Select, Input, Button, Spin, Table } from 'antd'
import moment from 'moment'
import {
  LAST_MONTH,
  LAST_YEAR,
  THIS_MONTH,
  THIS_YEAR,
  TODAY,
  YESTERDAY,
} from '../../const'
import {
  changeStringTime,
  changeStringTime2,
  changeToDecimal,
  copyToClip,
  fenToYuan,
} from '../../util'
// import ReserveDetail from './components/reserveDetail'
import { clickDownload } from '../../util/index'

const { RangePicker } = DatePicker

class RefundDetail extends React.Component {
  state = {
    list: [],
    period: {
      start_time: moment().format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },

    size: '0',
    visible: false,
    chosenRecord: {},
    loading: false,
    radioValue: 1,
  }

  componentWillUnmount() {}

  onChange = (value, dateString) => {
    if (value.length > 0) {
      this.setState({
        period: {
          start_time: dateString[0],
          end_time: dateString[1],
        },
      })
    } else {
      this.setState({
        period: {
          start_time: null,
          end_time: null,
        },
      }) //清除
    }
  }

  handleSizeChange = (e) => {
    this.setState({ size: e.target.value })
    this.getCurrentTimeByType(e.target.value) //时间范围
  }

  getCurrentTimeByType = (type) => {
    let startTime
    let endTime
    const today = moment().format('YYYY-MM-DD')
    //http://www.findsrc.com/article/momentjs_get_date
    if (type === YESTERDAY) {
      //昨天
      endTime = startTime = moment().subtract(1, 'day').format('YYYY-MM-DD')
    } else if (type === TODAY) {
      //今日
      startTime = endTime = today
    } else if (type === LAST_MONTH) {
      //上月
      startTime = moment()
        .subtract(1, 'month')
        .startOf('month')
        .format('YYYY-MM-DD')
      endTime = moment()
        .subtract(1, 'month')
        .endOf('month')
        .format('YYYY-MM-DD')
    } else if (type === THIS_MONTH) {
      //本月
      startTime = moment().startOf('month').format('YYYY-MM-DD')
      endTime = today
    } else if (type === LAST_YEAR) {
      //去年
      startTime = moment()
        .subtract(1, 'year')
        .startOf('year')
        .format('YYYY-MM-DD')
      endTime = moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD')
    } else if (type === THIS_YEAR) {
      //今年
      startTime = moment().startOf('year').format('YYYY-MM-DD')
      endTime = today
    }
    this.setState({
      period: {
        start_time: startTime,
        end_time: endTime,
      },
    })
  }

  handleButton = () => {
    const data = {
      club_id: sessionStorage.getItem('club_id'),
      start_time:
        moment(this.state.period.start_time).format('YYYY-MM-DD HH:mm:ss') ||
        '',
      end_time:
        moment(this.state.period.end_time).format('YYYY-MM-DD HH:mm:ss') || '',
      statisticType: this.state.radioValue,
    }
    this.setState({ loading: true })
    // this.props.fetchSearchExpend(data).then((res) => {
    //   this.setState({ loading: false })
    // })
    this.setState({ loading: false })
  }

  onTypeEvent = (type) => {
    this.setState({
      radioValue: type,
    })
  }

  onShowModal = (record) => {
    this.setState({
      visible: true,
      chosenRecord: record,
    })
  }

  handleReserveOk = () => {
    this.setState({ visible: false })
  }
  handleReserveCancel = () => {
    this.setState({ visible: false })
  }

  exportDetail = (reportName) => async () => {
    const { period, list, statisticType } = this.props
    if (
      period &&
      period.start_time &&
      period.end_time &&
      list &&
      list.length > 0
    ) {
      const cid = sessionStorage.getItem('club_id')
      const res = await exportClubPurchaseRecord({
        clubId: cid,
        startTime: moment(period.start_time).format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment(period.end_time).format('YYYY-MM-DD HH:mm:ss'),
        statisticType,
      })
      if (res) {
        const a = document.createElement('a')
        let href = window.URL.createObjectURL(res)
        a.href = href
        a.download = decodeURIComponent(`订单详情-${reportName}.xls`)
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(href)
      } else {
        message.error('导出失败')
      }
    }
  }

  render() {
    const { expendList, period, size } = this.state

    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '订单流水号',
        dataIndex: 'usage',
        key: 'usage',
      },
      {
        title: '退款流水号',
        dataIndex: 'ctime',
        key: 'ctime',
      },
      {
        title: '第三方流水号',
        dataIndex: 'serial_number',
        key: 'serial_number',
      },
      {
        title: '支付渠道',
        dataIndex: 'amounts',
        key: 'amounts',
      },
      {
        title: '退款原因',
        dataIndex: 'amounts',
        key: 'amounts',
      },
      {
        title: '退款金额',
        dataIndex: 'amounts',
        key: 'amounts',
      },
      {
        title: '订单金额',
        dataIndex: 'amounts',
        key: 'amounts',
      },
      {
        title: '状态',
        dataIndex: 'amounts',
        key: 'amounts',
      },
      {
        title: '退款时间',
        dataIndex: 'amounts',
        key: 'amounts',
      },
      {
        title: '商户号',
        dataIndex: 'amounts',
        key: 'amounts',
      },
      {
        title: '子商户号',
        dataIndex: 'amounts',
        key: 'amounts',
      },
      {
        title: '操作',
        dataIndex: 'amounts',
        key: 'amounts',
        render: (text, record, index) => {
          return (
            <div>
              <Button type="primary">刷新</Button>
              <Button type="primary">重新发起</Button>
            </div>
          )
        },
      },
    ]

    return (
      <div className="club_reserve_container">
        <div style={{ marginBottom: '10px' }}>
          <RangePicker
            showTime={false}
            format="YYYY-MM-DD"
            placeholder={['开始时间', '结束时间']}
            value={
              period.start_time
                ? [
                    moment(`${period.start_time}`, 'YYYY-MM-DD'),
                    moment(`${period.end_time}`, 'YYYY-MM-DD'),
                  ]
                : null
            }
            onChange={this.onChange}
          />
        </div>

        <div
          className="search_bar_box"
          style={{ display: 'flex', marginBottom: '10px' }}
        >
          <Select
            placeholder="状态"
            style={{ width: '150px', marginRight: '20px' }}
          >
            <Select.Option value="1">1</Select.Option>
            <Select.Option value="2">2</Select.Option>
            <Select.Option value="3">3</Select.Option>
          </Select>

          <Input
            placeholder="订单流水号"
            style={{ width: '150px', marginRight: '20px' }}
          ></Input>

          <Input
            placeholder="退款流水号"
            style={{ width: '150px', marginRight: '20px' }}
          ></Input>

          <Input
            placeholder="第三方流水号"
            style={{ width: '150px', marginRight: '20px' }}
          ></Input>

          <Button type="primary">查询</Button>
        </div>

        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Table
            rowKey="id"
            bordered
            columns={columns}
            dataSource={this.state.list}
            size="middle"
          />
        )}

        {/* <ReserveDetail
          visible={this.state.visible}
          record={this.state.chosenRecord}
          handleReserveOk={this.handleReserveOk}
          handleReserveCancel={this.handleReserveCancel}
        ></ReserveDetail> */}
      </div>
    )
  }
}

export default withRouter(RefundDetail)



// WEBPACK FOOTER //
// ./src/containers/RefundDetail/index.js